import { Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const steps = [
  {
    title: "1. Daftarkan jasa gratis",
    body: "Masuk dengan akun Google, isi nama usaha, tautan situs atau media sosial, kategori, dan deskripsi singkat. Listing langsung masuk antrean moderasi.",
  },
  {
    title: "2. Tampil di papan peringkat",
    body: "Setelah disetujui, listing tampil di papan live. Urutan ditentukan dari nilai promosi, dan pengunjung bisa langsung membuka situs Anda.",
  },
  {
    title: "3. Naikkan posisi kapan saja",
    body: "Ingin tampil paling atas? Tambahkan nilai promosi lewat pembayaran online. Setiap klik unik dari pengunjung dicatat sekali per hari agar statistik jujur.",
  },
];

const faqs = [
  {
    q: "Apakah mendaftar di jasasebar.com benar-benar gratis?",
    a: "Ya. Mendaftarkan listing tidak dipungut biaya. Pembayaran hanya diperlukan bila Anda ingin menaikkan posisi di papan peringkat.",
  },
  {
    q: "Bagaimana peringkat dihitung?",
    a: "Peringkat utama diurutkan dari total nilai promosi. Kami juga menampilkan peringkat harian dan mingguan agar listing baru tetap punya peluang terlihat.",
  },
  {
    q: "Apakah klik yang tercatat bisa dimanipulasi?",
    a: "Setiap pengunjung hanya dihitung satu kali per listing per hari. Klik berulang dari orang yang sama tidak menambah angka.",
  },
  {
    q: "Jenis usaha apa yang boleh didaftarkan?",
    a: "Jasa dan produk legal di Indonesia: desain, fotografi, servis, kuliner, les privat, toko online, dan lainnya. Konten penipuan, judi, atau dewasa akan ditolak.",
  },
  {
    q: "Apakah pembayaran aman?",
    a: "Pembayaran diproses oleh payment gateway resmi berlisensi Bank Indonesia, dan setiap transaksi punya halaman status serta invoice yang bisa Anda cek.",
  },
];

export function HomeGuide() {
  return (
    <section className="mx-auto max-w-6xl space-y-8 px-4 py-10">
      <div>
        <h2 className="font-display text-2xl font-semibold">Cara promosi jasa di jasasebar.com</h2>
        <p className="mt-2 max-w-3xl text-sm text-muted-foreground">
          jasasebar.com membantu pelaku usaha kecil Indonesia mendapat pengunjung tanpa harus memahami iklan digital
          yang rumit. Semua orang bisa melihat siapa yang sedang tampil teratas dan berapa klik yang mereka dapat.
        </p>
        <div className="mt-5 grid gap-4 md:grid-cols-3">
          {steps.map((s) => (
            <Card key={s.title}>
              <CardHeader className="pb-2">
                <CardTitle className="text-base">{s.title}</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">{s.body}</CardContent>
            </Card>
          ))}
        </div>
        <p className="mt-4 text-sm">
          Pelajari lebih lanjut di <Link to="/cara-kerja" className="underline">Cara Kerja</Link> atau baca tips
          promosi di <Link to="/blog" className="underline">Blog</Link>.
        </p>
      </div>
      <div>
        <h2 className="font-display text-2xl font-semibold">Pertanyaan umum</h2>
        <Accordion type="single" collapsible className="mt-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`f${i}`}>
              <AccordionTrigger className="text-left">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
